/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';
import { AccountCircle } from '@mui/icons-material';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import Person2Icon from '@mui/icons-material/Person2';
import HomeIcon from '@mui/icons-material/Home';
import EventIcon from '@mui/icons-material/Event';
import { Button, Box, MenuItem, IconButton, Tooltip } from '@mui/material';
import { Dropdown } from 'app/components/shared/dropdown/Dropdown';
import { ROUTE_PATHS } from 'app/utils/route';
import { useSelector } from 'react-redux';
import { getUser } from 'redux/auth/authSlice';
import { AppLogo } from 'components/common/AppLogo';
import { useCommonInits } from 'hooks/useCommonInits';
import { getApcmGroup } from 'redux/datasource/dataSourceActions';
import { useSignOut } from '../../auth/useAuth';
import { AppConfirmDialog } from '../../components/common/AppConfirmDialog';
import { closedMixin, DRAWER_WIDTH, openedMixin } from './shared/themeUtils';
import { getGroupsbyId } from 'redux/datasource/dataSourceSlice';

const Drawer = styled(MuiDrawer, {
    shouldForwardProp: prop => prop !== 'open',
})(({ theme, open }) => ({
    width: 'auto',
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': closedMixin(theme),
    }),
}));

const paperStyles = {
    overflow: 'visible',
    flexDirection: 'column',
    justifyContent: 'space-between',
};

export default function MiniDrawer({ isOpen, drawerToggle }) {
    const [confirmLogout, setConfirmLogout] = useState(false);
    const signout = useSignOut();
    const theme = useTheme();
    const { navigate, dispatch } = useCommonInits();
    const user = useSelector(getUser);
    // const units = useSelector(getUnitIds);
    const [groupId, setGroupId] = useState('');
    const getGroup = useSelector(getGroupsbyId);
    const navigateTo = (path, params = {}) => {
        navigate(path, params);
    };
    // const unitIds = JSON.parse(units);

    // const filteredGroups = getGroup.filter(val => {
    //     if(unitIds.length > 0){
    //     return unitIds.find(a => {
    //         return val.name === a;
    //     });}
    // });

    useEffect(() => {
           const groupName =  getGroup?.name;
           if(groupName){
                const ggId = getGroup?._id
                const groups = user?.unit_id;
                console.log(groups);
                if(groups.includes(groupName) && user?.app_type?.includes('APCM_Authorizer')){
                    
                        navigateTo(`/${ROUTE_PATHS.groupId}/${ggId}`);
                } else if(groups.includes(groupName) && user?.app_type?.includes('APCM_Executor')){
                        
                        navigateTo(`/${ROUTE_PATHS.executor}/${ggId}`);
                } else if(!user?.app_type?.includes('APCM')){
                     navigateTo(ROUTE_PATHS.apcmDashboard)
                }
        }
    }, [getGroup])

    const preferencesOption = () => (
        <Typography
            component="div"
            className="dropdown"
            sx={{ bgcolor: 'background.default', marginBottom: '1rem' }}
        >
            <IconButton className="btn-dropdown" color="inherit">
                <AccountCircle fontSize="large" />
            </IconButton>

            <Dropdown>
                <Typography
                    component="div"
                    className="dropdown-content"
                    sx={{ marginTop: '-8vh' }}
                >
                    <div className="dropdown-items">
                        <MenuItem onClick={() => setConfirmLogout(true)}>
                            <Typography>Log Out</Typography>
                        </MenuItem>

                        <MenuItem
                            onClick={() => navigateTo(ROUTE_PATHS.settings)}
                        >
                            <Typography>Preferences</Typography>
                        </MenuItem>

                        <MenuItem>
                            <Typography component="div" variant="h6">
                                {user?.username}
                            </Typography>
                        </MenuItem>
                    </div>
                </Typography>
            </Dropdown>
        </Typography>
    );

    const handleLogout = () => {
        setConfirmLogout(false);
        signout();
    };

    const renderLogoutDialog = () => (
        <AppConfirmDialog
            open={confirmLogout}
            title="Logout Confirmation"
            message="Are you sure you want to logout?"
            confirmText="Logout"
            cancelText="Cancel"
            onConfirm={handleLogout}
            onCancel={() => setConfirmLogout(false)}
        />
    );

    const renderGroupId = id => {
        setGroupId(id);
        dispatch(getApcmGroup({ id }));
    };

    const renderExecuterId = id => {
        setGroupId(id);
        dispatch(getApcmGroup({ id }));
    };

    const renderEvents = () => {
        navigateTo(`/${ROUTE_PATHS.userEvent}`);
    };
    const drawerContent = () => (
        <>
            <Box sx={{ position: 'relative' }}>
                <AppLogo />
                <div>
                    <Tooltip title="Dashboard">
                        <Button
                            onClick={() =>
                                navigateTo(`/${ROUTE_PATHS.apcmDashboard}`)
                            }
                            sx={{
                                bgcolor: 'background.default',
                                marginLeft: '10px',
                                // height: 70,
                                // width: 70,
                                marginBottom: '20px',
                            }}
                        >
                            <HomeIcon fontSize="large" />
                        </Button>
                    </Tooltip>
                </div>

                {user?.app_type.includes('APCM') ? (
                    <div>
                        <div>
                            <Tooltip title="Groups">
                                <Button
                                    onClick={() =>
                                        navigateTo(`/${ROUTE_PATHS.groups}`)
                                    }
                                    sx={{
                                        bgcolor: 'background.default',
                                        marginLeft: '10px',
                                        marginBottom: '20px',

                                        // height: 70,
                                        // width: 70,
                                    }}
                                >
                                    <GroupAddIcon fontSize="large" />
                                </Button>
                            </Tooltip>
                        </div>

                        <div>
                            <Tooltip title="Users">
                                <Button
                                    onClick={() =>
                                        navigateTo(`/${ROUTE_PATHS.user}`)
                                    }
                                    sx={{
                                        bgcolor: 'background.default',
                                        marginLeft: '10px',
                                        // height: 70,
                                        // width: 70,
                                        marginBottom: '20px',
                                    }}
                                >
                                    <Person2Icon fontSize="large" />
                                </Button>
                            </Tooltip>
                        </div>
                    </div>
                ) : (
                    ''
                )}

                {/* {user.user_role === 'Authorizer' ? (
                    

            <Typography
                    component="div"
                    className="dropdown"
                    sx={{ bgcolor: 'background.default' }}
                >
                    <Tooltip style={{width:'110px',fontSize:'25px'}} title= {'Groups'}>
                    <Button className="btn-dropdown">
                    <PeopleIcon  fontSize='large'/>

                    </Button>
                    </Tooltip>

                    <Dropdown>
                        <Typography
                            component="div"
                            className="dropdown-content"
                        >
                            <div className="dropdown-items">
                            {filteredGroups?.map((group, i) => (
                                <MenuItem
                                   
                                   onClick={() => renderGroupId(group._id)}>
                                   <Typography>  {group.name}</Typography> 
                                
                                    
                                </MenuItem>                             
                            ))}
                               
                            </div>
                        </Typography>
                    </Dropdown>
                </Typography>
                    
                ) : (
                    ''
                )} */}

                {/* {user.user_role === 'Executor' ? (
                     <Typography
                     component="div"
                     className="dropdown"
                     sx={{ bgcolor: 'background.default' }}
                 >
                     <Tooltip style={{width:'110px',fontSize:'25px'}} title= {'Groups'}>
                     <Button className="btn-dropdown">
                     <PeopleIcon  fontSize='large'/>
 
                     </Button>
                     </Tooltip>
 
                     <Dropdown>
                         <Typography
                             component="div"
                             className="dropdown-content"
                         >
                             <div className="dropdown-items">
                             {filteredGroups?.map((group, i) => (
                                 <MenuItem
                                    
                                    onClick={() => renderExecuterId(group._id)}>
                                    <Typography>  {group.name}</Typography> 
                                 
                                     
                                 </MenuItem>                             
                             ))}
                                
                             </div>
                         </Typography>
                     </Dropdown>
                 </Typography>
                ) : (
                    ''
                )} */}
                <div>
                    <Tooltip title="User events">
                        <Button
                            onClick={() => renderEvents()}
                            sx={{
                                bgcolor: 'background.default',
                                marginLeft: '10px',
                                // height: 70,
                                // width: 70,
                                marginTop: '10px',
                            }}
                        >
                            <EventIcon fontSize="large" />
                        </Button>
                    </Tooltip>
                </div>
            </Box>
            {preferencesOption()}
            {confirmLogout && renderLogoutDialog()}
        </>
    );

    return (
        <Box>
            <Drawer
                variant="permanent"
                open
                PaperProps={{
                    style: paperStyles,
                }}
                onClose={drawerToggle}
                theme={theme}
                sx={{
                    display: { xs: 'none', sm: 'block' },
                    '& .MuiDrawer-paper': {
                        boxSizing: 'border-box',
                        width: DRAWER_WIDTH,
                    },
                }}
            >
                {drawerContent()}
            </Drawer>
        </Box>
    );
}

